import {Button, Col, Row} from "react-bootstrap";
import React from "react";
import * as PropTypes from "prop-types";

export function SurveySectionFooter(props) {
	return <Row>
		<Col xs={12}>
			{
				props.editMode ?
					(
						props.lastIndex ?
							<Button onClick={props.onSaveAndFinish} variant="primary" className="float-right"
							        disabled={!props.isValid}>
								Save and Finish
							</Button> :
							<Button onClick={props.onSaveAndContinue} variant="primary" className="float-right"
							        disabled={!props.isValid}>
								Save and Continue
							</Button>
					) :
					null
			}
		</Col>
	</Row>;
}

SurveySectionFooter.propTypes = {
	editMode: PropTypes.any,
	lastIndex: PropTypes.bool,
	onSaveAndFinish: PropTypes.any,
	isValid: PropTypes.any,
	onSaveAndContinue: PropTypes.any
};